// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/.store/css-loader@3.6.0/node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".video-avatar[data-v-69bb9245]{width:25rem;height:25rem;margin-bottom:3.125rem}.video-avatar .bight[data-v-69bb9245]{width:6.25rem;height:3.125rem;position:absolute;top:80%;left:50%}", ""]);
// Exports
module.exports = exports;
